import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as ChevronDownIcon } from "bootstrap-icons/icons/chevron-down.svg";
// import LogoutButton from "../components/utils/LogoutButton"

const SidebarSection = ({ title, links, isOpen, onToggle }) => {
    const location = useLocation();

    // Single-link sections render as a flat top-level item (no dropdown)
    if (links.length === 1) {
        const { to, label } = links[0];
        const isActive = location.pathname === to;
        return (
            <div className="rounded-lg">
                <Link
                    to={to}
                    className={`flex items-center w-full px-4 py-2 text-left rounded-lg focus:outline-none transition duration-500 ease-in-out ${
                        isActive
                            ? "bg-gray-200 text-darkGreen3 font-bold"
                            : "bg-gray-200 text-black2 hover:text-darkGreen3"
                    }`}
                >
                    <span>{label}</span>
                </Link>
                <hr className="border border-lGrey" />
            </div>
        );
    }

    return (
        <div className="rounded-lg">
            <button
                className="flex justify-between w-full px-4 py-2 text-left bg-gray-200 rounded-t-lg focus:outline-none"
                onClick={onToggle}
            >
                <span className="text-black2">{title}</span>
                <ChevronDownIcon
                    className={`transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
                />
            </button>
            {isOpen && (
                <div className="p-4 bg-white rounded-b-lg">
                    <ul>
                        {links.map(({ to, label }) => (
                            <li key={to}>
                                <Link
                                    className={`${location.pathname === to
                                        ? "text-darkGreen3 font-bold"
                                        : "text-grey2 hover:text-darkGreen3"
                                        } inline-flex items-center w-full mt-1 text-base transition duration-500 ease-in-out transform rounded-lg focus:shadow-outline`}
                                    to={to}
                                >
                                    <span>{label}</span>
                                </Link>
                            </li>

                        ))}

                    </ul>
                </div>
            )}
            <hr className="border border-lGrey" />
        </div>
    );
};

export default SidebarSection;
